import { render, staticRenderFns } from "./TestCheckoutSections.vue?vue&type=template&id=5152c4d4"
import script from "./TestCheckoutSections.vue?vue&type=script&lang=js"
export * from "./TestCheckoutSections.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports